<template>
  <div v-html="agreement" />
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
  name: "Agreement",
  data(){
    return {
      agreement:""
    }
  },
  mounted() {
    this.start();
  },
  methods:{
    start() {
      Fetch("/user/agreement",{id: this.$router.history.current.params.id}).then((r) => {
        this.agreement = r.data;
      });
    },
  }
}
</script>

<style>
.seal{ background: url("../../assets/images/self.png") no-repeat;background-size: cover; width: 150px; height: 150px;position: absolute;top:30px;left:90px;}


.sealgs{ background: url("../../assets/images/pingan.png") no-repeat;background-size: cover; width: 150px; height: 150px;position: absolute;top:-50px;left:130px;}

</style>
